import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import HeaderSecondary from 'flarum/forum/components/HeaderSecondary';
import ThemeToggle from './components/ThemeToggle';
import ThemePreferenceService from './services/ThemePreferenceService';
app.initializers.add('devconnect-theme-toggle', () => {
  // Один экземпляр сервиса обслуживает раннее применение сохранённой схемы и все последующие
  // перерисовки шапки, поэтому компоненты не создают конкурирующие состояния localStorage.
  const preference = new ThemePreferenceService(window.localStorage, document.documentElement);
  const savedTheme = preference.preferred();
  app.beforeMount(() => {
    // Модель forum создаётся после initializers, поэтому серверную настройку нельзя читать раньше этой стадии.
    const configuredTheme = app.forum.attribute('devconnectThemeDefaultScheme');
    const initialTheme = savedTheme || (['light', 'dark'].includes(configuredTheme) ? configuredTheme : null);

    // Локальный выбор применяется после инициализации Flarum как дополнительная страховка.
    // Основной сценарий без вспышки выполняет серверный ThemeBootstrap до загрузки CSS.
    if (initialTheme) {
      preference.apply(initialTheme);
      app.setColorScheme(initialTheme);

      // Ядро Flarum повторно вычисляет auto-схему в конце синхронного mount. Микрозадача выполняется
      // после boot, но до следующей отрисовки, и возвращает приоритет явно сохранённому выбору.
      queueMicrotask(() => {
        preference.apply(initialTheme);
        app.setColorScheme(initialTheme);
        m.redraw();
      });
    }
  });

  // Элемент встраивается в штатный HeaderSecondary между поиском и пользовательскими действиями.
  // Это сохраняет адаптивное поведение Flarum и не создаёт отдельную самописную панель шапки.
  extend(HeaderSecondary.prototype, 'items', function (items) {
    if (app.forum.attribute('devconnectThemeToggleEnabled') !== false) {
      items.add('devconnect-theme-toggle', m(ThemeToggle, {
        preference
      }), 25);
    }
  });
});